export default __webpack_public_path__ + "static/media/problema-07.5c3fcd5e.webp";